import { getAndAddReplayTrack } from './Playlist';

export default {
  getAndAddReplayTrack,
};
